import React, { useState } from 'react';
import { useVersion } from '../context/VersionContext';
import './VersionFooter.css';

/**
 * VersionFooter — Exibe versão no canto inferior esquerdo
 *
 * DESIGN:
 * - Fixo no canto inferior esquerdo, z-index alto
 * - Texto pequeno (11px), semi-transparente
 * - Tooltip com info de build
 * - Pulse/fade quando atualização disponível
 * - Sem impacto visual em modo normal
 */

export function VersionFooter() {
  const { localVersion, isUpdateAvailable, lastChecked, checkNow } = useVersion();
  const [showTooltip, setShowTooltip] = useState(false);

  // Formata data do último check
  const lastCheckedStr = lastChecked
    ? new Date(lastChecked).toLocaleString('pt-BR', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    : 'nunca';

  return (
    <div
      className={`version-footer ${isUpdateAvailable ? 'update-available' : ''}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={checkNow}
      title="Clique para verificar atualização"
    >
      {/* Versão */}
      <span className="version-text">
        v{localVersion}
      </span>

      {/* Badge de atualização disponível */}
      {isUpdateAvailable && (
        <span className="update-badge">●</span>
      )}

      {/* Tooltip */}
      {showTooltip && (
        <div className="version-tooltip">
          <div>Versão: {localVersion}</div>
          <div>Última verificação: {lastCheckedStr}</div>
          {isUpdateAvailable && (
            <div className="update-notice">
              ↻ Nova versão disponível
            </div>
          )}
        </div>
      )}
    </div>
  );
}
